import React from 'react';
export function StepHeading({
  title,
  intro
}: {
  title: string;
  intro?: string;
}) {
  return <div className="mb-7" data-id="element-763" data-mp="2or8bz60q4ftx">
      <h1 className="font-display text-3xl font-black leading-tight tracking-tight text-magenta sm:text-4xl" data-id="element-764" data-mp="2ori00o27kcwz">{title}</h1>
      {intro && <p className="mt-2 max-w-2xl text-base leading-relaxed text-ink-600" data-id="element-765" data-mp="2at1ydbj7dclp">{intro}</p>}
    </div>;
}